'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFaasProcedureConfig = exports.defaultCreateFetchOptionsFromCallArgs = exports.defaultFaasFetchOpts = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

require('fetch-everywhere');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _getJSONHeaders = require('./getJSONHeaders');

var _getJSONHeaders2 = _interopRequireDefault(_getJSONHeaders);

var _getFaasApiUrl = require('./getFaasApiUrl');

var _getFaasApiUrl2 = _interopRequireDefault(_getFaasApiUrl);

var _hashWithoutPrototypes = require('./hashWithoutPrototypes');

var _hashWithoutPrototypes2 = _interopRequireDefault(_hashWithoutPrototypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var defaultFaasFetchOpts = exports.defaultFaasFetchOpts = {
  credentials: 'include',
  headers: (0, _getJSONHeaders2.default)(),
  method: 'POST'
};

var defaultCreateFetchOptionsFromCallArgs = exports.defaultCreateFetchOptionsFromCallArgs = function defaultCreateFetchOptionsFromCallArgs(args) {
  return { body: JSON.stringify(args) };
};

var createFaasProcedureConfig = exports.createFaasProcedureConfig = function createFaasProcedureConfig(functionName) {
  var createFetchOptsFromCallArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCreateFetchOptionsFromCallArgs;
  var hashFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _hashWithoutPrototypes2.default;

  if (!functionName || typeof functionName !== 'string') {
    throw new Error('functionName must be a string (was ' + (functionName ? typeof functionName === 'undefined' ? 'undefined' : _typeof(functionName) : 'falsey') + ')');
  }
  if (typeof createFetchOptsFromCallArgs !== 'function') {
    throw new TypeError('createFetchOptsFromCallArgs must be a function (was ' + (typeof createFetchOptsFromCallArgs === 'undefined' ? 'undefined' : _typeof(createFetchOptsFromCallArgs)) + ')');
  }

  return {
    call: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var _ref2$fetchClient = _ref2.fetchClient,
            fetchClient = _ref2$fetchClient === undefined ? fetch : _ref2$fetchClient,
            getState = _ref2.getState,
            _ref2$args = _ref2.args,
            args = _ref2$args === undefined ? {} : _ref2$args,
            _ref2$handleResponse = _ref2.handleResponse,
            handleResponse = _ref2$handleResponse === undefined ? true : _ref2$handleResponse;
        var fetchOpts, res, textBody;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetchOpts = _deepmerge2.default.all([defaultFaasFetchOpts, { headers: { 'one-data-correlation-id': (0, _v2.default)() } }, createFetchOptsFromCallArgs(args)]);
                _context.next = 3;
                return fetchClient((0, _getFaasApiUrl2.default)(getState()) + '/' + functionName, fetchOpts);

              case 3:
                res = _context.sent;

                if (handleResponse) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', res);

              case 6:
                _context.next = 8;
                return res.text();

              case 8:
                textBody = _context.sent;

                if (res.ok) {
                  _context.next = 11;
                  break;
                }

                throw new Error(textBody);

              case 11:
                _context.prev = 11;
                return _context.abrupt('return', JSON.parse(textBody));

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](11);
                return _context.abrupt('return', textBody);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined, [[11, 15]]);
      }));

      return function call(_x3) {
        return _ref.apply(this, arguments);
      };
    }(),
    getResultFromCache: function getResultFromCache(_ref3) {
      var args = _ref3.args,
          cache = _ref3.cache;

      var hashedArgs = hashFunction(args);
      if (!cache.has(hashedArgs)) {
        throw new Error('make the call');
      }
      return cache.get(hashedArgs);
    },
    buildUpdatedCache: function buildUpdatedCache(_ref4) {
      var cache = _ref4.cache,
          args = _ref4.args,
          result = _ref4.result,
          error = _ref4.error;
      return typeof result === 'undefined' && typeof error === 'undefined' ? cache.remove(hashFunction(args)) : cache.set(hashFunction(args), error || result);
    },
    functionName: functionName
  };
};